import React, { useEffect, useState } from "react";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { HomeUploader } from "./HomeUploader.js";
import { guid } from "../Helpers/helpers.js";

export const UploaderApiInitWrapper = () => {
  const [loading, setLoading] = useState(true);
  const { setUploadId, getUploadId, getMailId } = useUploader();

  useEffect(() => {
    // uid is used to identify the upload session
    if (!getMailId()) {
      const uid = guid();
      setLoading(false);
      // set the upload id in the context
      setUploadId(uid);
    }
  }, [getMailId()]);

  return !loading && getUploadId() ? <HomeUploader /> : "...";
};
